import { Reducer } from 'redux';
import { getImpersonating } from 'services/storage';
import { getType } from 'typesafe-actions';
import {
  changePassword,
  clearBellNotifications,
  editProfile,
  impersonate,
  logIn,
  logOut,
  requestResetPassword,
  resetPassword,
  saveToken,
  setGroupCode,
  signUp,
  support,
  verify,
} from './actions';
import { AuthAction, AuthState } from './types';

export const INITIAL_STATE: AuthState = {
  init: false,
  loading: false,
  user: null,
  impersonating: getImpersonating(),
};

const reducer: Reducer<AuthState, AuthAction> = (
  state = INITIAL_STATE,
  action,
) => {
  switch (action.type) {
    case getType(setGroupCode.request):
    case getType(changePassword.request):
    case getType(requestResetPassword.request):
    case getType(resetPassword.request):
    case getType(editProfile.request):
    case getType(support.request):
      return {
        ...state,
        loading: true,
      };
    case getType(changePassword.failure):
    case getType(changePassword.success):
    case getType(requestResetPassword.failure):
    case getType(requestResetPassword.success):
    case getType(setGroupCode.success):
    case getType(setGroupCode.failure):
    case getType(support.success):
    case getType(support.failure):
    case getType(resetPassword.failure): {
      return {
        ...state,
        loading: false,
      };
    }
    case getType(editProfile.success):
      return {
        ...state,
        loading: false,
        user: action.payload,
      };
    case getType(editProfile.failure):
      return {
        ...state,
        loading: false,
      };
    case getType(logIn.request):
    case getType(saveToken.request):
    case getType(impersonate.request):
      return {
        ...state,
        loading: true,
      };
    case getType(resetPassword.success):
    case getType(logIn.success):
    case getType(saveToken.success):
      return {
        ...state,
        loading: false,
        user: action.payload,
        impersonating: false,
      };
    case getType(impersonate.success):
      return {
        ...state,
        loading: false,
        user: action.payload,
        impersonating: true,
      };
    case getType(impersonate.failure):
      return {
        ...state,
        loading: false,
        impersonating: false,
      };
    case getType(logIn.failure):
    case getType(saveToken.failure):
      return {
        ...state,
        loading: false,
      };
    case getType(logOut.request):
      return {
        ...state,
        loading: true,
        user: null,
        impersonating: false,
      };
    case getType(logOut.success):
      return {
        ...state,
        loading: false,
      };
    case getType(logOut.failure):
      return {
        ...state,
        loading: false,
      };
    case getType(signUp.request):
      return {
        ...state,
        loading: true,
      };
    case getType(signUp.success):
      return {
        ...state,
        loading: false,
      };
    case getType(signUp.failure):
      return {
        ...state,
        loading: false,
      };
    case getType(verify.success):
      return {
        ...state,
        init: true,
        user: action.payload,
      };
    case getType(verify.failure):
      return {
        ...state,
        init: true,
        impersonating: false,
      };
    case getType(clearBellNotifications):
      return {
        ...state,
        user: state.user
          ? {
              ...state.user,
              hasUnreadBellNotifications: false,
            }
          : null,
      };
    default:
      return state;
  }
};

export default reducer;
